import { connect, Dispatch } from 'react-redux';

import { PriceAdjustmentsPage, PriceAdjustmentsProperties } from './price-adjustments-page.component';
import { CoveragePageProperties } from '../coverage.reducer';
import {
  triggerGetCoverageOptions,
  triggerGetPriceAdjustments,
  setPriceAdjustmentAmount,
  getEmployeeDiscount,
  selectEmployeeDiscount,
  setEmployeeDiscountEnabled,
  updateTotalPrice,
  triggerSaveCoverage,
  updateSelections,
  saveNotes
} from '../_actions/coverage.actions';
import { GetPriceAdjustmentMetadata, PriceAdjustmentViewModel } from '@models/Product';

import { setPriceAdjustmentSelection } from '../_actions/coverage.actions';
import { EmployeeDiscountViewModel } from '@models/Product';
import { doAsync } from '@common/components/common.actions';
import { AppState } from 'src';
import { CoverageForm } from './product-n-coverages.component';
import { blankStatesVM } from '@models/common.models';
import { setIsStoringPriceAdjustmentInfo } from '../../order-edit/order-edit.actions';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(globalState: AppState, ownProps: CoveragePageProperties): Partial<PriceAdjustmentsProperties> {
  const state = globalState.coverageStep;
  return {
    productAndCoverageOptions: {
      isQuote: ownProps.isQuote || false,
      productGroups: state.productGroups || [],
      products: state.products || [],
      priceAdjustments: state.priceAdjustments || [],

      propertyTypeId: ownProps.propertyTypeId,
      stateAbbreviation: (ownProps.state || blankStatesVM).abbreviation,
      zipCode: ownProps.zipCode,
      employeeDiscounts: state.employeeDiscounts || [],
      isEmployeeDiscountEnabled: state.isEmployeeDiscountEnabled,

      selectedGroupId: state.selectedGroupId,
      selectedProductId: (state.selectedProduct || { id: -1 }).id,
      selectedPriceAdjustment: state.selectedPriceAdjustment || {
        id: 0,
        value: '<None>',
        increase: false,
        adjustmentAmount: 0,
        percentageAmount: 0
      },

      hasSellersCoverage: state.sellerCoverage,
      buttonRef: ownProps.buttonRef,
      selectedEmployeeDiscount: state.selectedEmployeeDiscount,
      overridePriceAdjustmentAmount: state.overridePriceAdjustmentAmount,
      orderType: globalState.contract.orderType,
      contractVM: ownProps.contractVM
    },
    selectedProduct: state.selectedProduct,
    coverageOptions: state.coverageOptions || [],
    selectedCoverageOptions: state.selectedCoverageOptions,
    calculationModel: {
      totalPrice: state.subTotal,
      sellerCoverage: state.sellerCoverage,
      buyerTotalPrice: state.buyerTotalPrice,
      sellerTotalPrice: state.sellerTotalPrice,
      employeeDiscounts: state.employeeDiscounts || [],
      totalAdjustment: state.totalAdjustments,

      extraCharge: state.extraCharge,

      priceAdjustment: state.selectedPriceAdjustment,
      overridePriceAdjustmentAmount: state.overridePriceAdjustmentAmount,
      employeeDiscount: state.selectedEmployeeDiscount
    },
    currentStep: ownProps.currentStep || 0,
    isOrderEdit: ownProps.isOrderEdit,
    isOpenContract: globalState.contract.isOpenContract
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: CoveragePageProperties
): Partial<PriceAdjustmentsProperties> {
  return {
    onLeave: () => {
      dispatch(triggerSaveCoverage());
    },
    onMount: () => {
      const adjustmentMetaData: GetPriceAdjustmentMetadata = {
        hasPropertyManagement: ownProps.hasPropertyManagement,
        hasAgent: ownProps.hasAgent,
        customerId: ownProps.buyerId,
        stateAbbreviation: (ownProps.state || blankStatesVM).abbreviation,
        zipCode: ownProps.zipCode,
        hasEmployeeDiscounts: false // overwritten from state inside trigger get adjustments
      };

      let dropdownsPromise = Promise.all([
        dispatch(triggerGetPriceAdjustments(adjustmentMetaData)),
        dispatch(triggerGetCoverageOptions(ownProps.isRenewal))
      ]);

      if (ownProps.buyerId) {
        dispatch(getEmployeeDiscount(ownProps.buyerId));
      }
      dropdownsPromise.then(() => {
        return dispatch(updateSelections()).then(() => {
          dispatch(updateTotalPrice());
        });
      });
    },
    selectEmployeeDiscount: (employeeDiscount: EmployeeDiscountViewModel) => {
      dispatch(doAsync(selectEmployeeDiscount(employeeDiscount))).then(() => {
        dispatch(updateTotalPrice());
      });
    },

    selectPriceAdjustment: (adjustment: PriceAdjustmentViewModel) => {
      dispatch(doAsync(setPriceAdjustmentSelection(adjustment)))
        .then(() => {
          const enabled = adjustment.id === 132 || adjustment.id === 134;
          if (!enabled) {
            dispatch(doAsync(selectEmployeeDiscount(undefined))); // deselect it
          }
          dispatch(setEmployeeDiscountEnabled(enabled));
        })
        .then(() => {
          dispatch(updateTotalPrice());
        });
    },
    setPriceAdjustmentAmount: (amount: number) => {
      dispatch(doAsync(setPriceAdjustmentAmount(amount))).then(() => {
        dispatch(updateTotalPrice());
      });
    },
    onSaveClick: (model: CoverageForm) => {
      dispatch(triggerSaveCoverage()).then(() => {
        dispatch(saveNotes(model))
          .then(() => {
            if (ownProps.next) {
              ownProps.next();
            }
          })
          .then(() => dispatch(setIsStoringPriceAdjustmentInfo(false)));
      });
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const PriceAdjustmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PriceAdjustmentsPage);



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_components/price-adjustments.container.tsx